module.exports = __webpack_public_path__ + "images/slide1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/slide1.png
// module id = 1134
// module chunks = 0